
<template>
  <div class="productDetails">
    <div class="banner">
      <img src="@/assets/product/Product Center.png" alt>
    </div>
    <div class="text inner">
      <p>再制造销售/租赁</p>
      <p>&mdash;&nbsp;Remanufacturing sales / leasing&nbsp;&mdash;</p>
    </div>
    <div class="roductCon inner">
      <img src="@/assets/home/DZ2010AC.png" alt="">
      <div class="roductConTxt">
        <p>柯美C364E 彩色数码复合机 适用30-60人办公</p>
        <p>打印/复印/扫描/双面打印<br>免印量黑白2000张/月<br>彩色200张/月<br>超印：黑白0.05元/页，彩色0.5元/页</p>
        <p>联系我们</p>
      </div>
    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/productDetails.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage
  },
}
</script>

<style>
</style>